import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import CrmNavbarUI from '../../component/CrmUI/CrmNavbarUI/CrmNavbarUI';
import CrmSideBarUI from '../../component/CrmUI/CrmSideBarUI/CrmSideBarUI';
import { useCrm } from '../../context/CrmContext';

const CrmRoleProtectedRoute = ({ children, allowedRoles }) => {
    const { isAuthenticated, roles } = useCrm();

    if (isAuthenticated === null) {
        return <div className='text-center pt-64'>
            <CircularProgress size={30} color='secondary' />
        </div>;
    }

    console.log("lqwkjdlkqwj ==>>>", isAuthenticated, roles);

    if (!isAuthenticated) {
        return <Navigate to='/crm/login' />;
    }

    if (!allowedRoles.some(role => roles.includes(role))) {
        return <Navigate to="/crm/login" />;
    }

    return (
        <div className="bg-[#F8F7FA] max-h-screen flex ">
            <Box className="hidden md:block shadow-2xl bg-[#001529]">
                <CrmSideBarUI/>
            </Box>

            <Box component="main" sx={{ flexGrow: 1, maxHeight: "100%", overflowY: "auto" }}>
                <CrmNavbarUI/>
                <Box className="lg:p-6 sm:p-4 p-1 overflow-auto">{children}</Box>
            </Box>
        </div>
    );
};

export default CrmRoleProtectedRoute;
